import { render } from "./Device.vue?vue&type=template&id=3587b026"
import script from "./Device.vue?vue&type=script&setup=true&lang=js"
export * from "./Device.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Devices/Device.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3587b026"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3587b026', __exports__)) {
    api.reload('3587b026', __exports__)
  }
  
  module.hot.accept("./Device.vue?vue&type=template&id=3587b026", () => {
    api.rerender('3587b026', render)
  })

}


export default __exports__